<div class="teams-table__container">
  <table #teamsTableEl mat-table class="teams-table" [dataSource]="dataSource" [trackBy]="trackByFn">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let team; let idx = index">
        <div class="teams-table__name">
          <oph-avatar [name]="team.name | titlecase" [type]="'other'" [size]="28"></oph-avatar>
          <span [title]="team.name">{{ team.name }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Members Column -->
    <ng-container matColumnDef="members">
      <th mat-header-cell *matHeaderCellDef>Members</th>
      <td mat-cell *matCellDef="let team">
        <teams-members-avatars [team]="team" />
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let team; columns: displayedColumns" (click)="onTeamClick(team)"></tr>
    <tr *matNoDataRow>
      <td class="teams-table__empty" [attr.colspan]="displayedColumns.length">No teams were found.</td>
    </tr>
  </table>

  <div class="teams-table__paginator-container">
    @if ((searchValue$() | async) === '') {
      <oph-paginator
        [page]="currentPage + 1"
        [totalPages]="totalPages()"
        (pageChange)="onPageChange($event)"
        [preventRouting]="true"
      />
    }
  </div>
</div>
